import i18n from 'modules/core/lib/i18n'

import customDocsImage from 'modules/documents/lib/assets/upsell_custom.png'
import employeeInfoImage from 'modules/documents/lib/assets/upsell_info.png'
import spainModelImage from 'modules/documents/lib/assets/upsell_spain.png'

const VALID_ISO_CODE = ['es']

export const enterpriseDocumentsContent = (isoCountryCode: string) => {
  const spainContent = {
    src: spainModelImage,
    title: i18n.t('documents.upsell_modal.spain_model.title'),
    description: i18n.t('documents.upsell_modal.spain_model.description'),
  }

  const content = [
    {
      src: customDocsImage,
      title: i18n.t('documents.upsell_modal.custom_docs.title'),
      description: i18n.t('documents.upsell_modal.custom_docs.description'),
    },
    {
      src: employeeInfoImage,
      title: i18n.t('documents.upsell_modal.collect_info.title'),
      description: i18n.t('documents.upsell_modal.collect_info.description'),
    },
  ]

  if (VALID_ISO_CODE.includes(isoCountryCode)) content.push(spainContent)

  return content
}
